var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beige",class:{ flash: _vm.flash }},[_c('v-icon',{staticClass:"beige-ico"},[_vm._v(" mdi-information-outline ")]),_c('span',{staticClass:"beige-text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }